import React from 'react'
import Banner from '../components/Banner'
import FaqDetails from '../components/Faq/FaqDetails'

const Faq = () => {
    return (
        <>
            <Banner image={'faqbanner'} />
            <FaqDetails />
        </>
    )
}

export default Faq